module.exports = __webpack_public_path__ + "img/logo_epice.6a0baf49.png";